"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_MIP_RECORDS = exports.UPDATE_PRACTICE_REQUIREMENT = exports.QUERY_MIP_CONTACT = exports.QUERY_MIP_ATTESTATION = exports.QUERY_MIP_AML_ATTESTATION = exports.QUERY_MIP_AML = exports.MUTATE_SEND_ORDER_CONFIRMATION_MIP = exports.CREATE_MIP_ATTESTATION = exports.CREATE_AML_ATTESTATION = exports.GET_MIP_PRACTICE_DETAILS = exports.GET_PRACTICE_HISTORY = exports.GET_WORK_HISTORY = exports.CREATE_PRACTICE_HISTORY = exports.CREATE_WORK_HISTORY = exports.UPDATE_MIP_AML = exports.CREATE_MIP_AML = exports.CREATE_MIP_CONTACT = void 0;
exports.CREATE_MIP_CONTACT = `
	mutation createMipContact($contact: ContactInfo){
		createMipContact(contact: $contact) 
	}
`;
exports.CREATE_MIP_AML = `
	mutation createMipAml($aml: AML){
		createMipAml(aml: $aml) 
	}
`;
exports.UPDATE_MIP_AML = `
	mutation updateMipAml($aml: AML){
		updateMipAml(aml: $aml) 
	}
`;
exports.CREATE_WORK_HISTORY = `
	mutation upsertWorkHistory($workHistory: WorkHistory){ 
		upsertWorkHistory(workHistory: $workHistory) 
	}
`;
exports.CREATE_PRACTICE_HISTORY = `
	mutation createPracticeRequirement($practiceRequirement: PracticeDetails){ 
		createPracticeRequirement(practiceRequirement: $practiceRequirement) 
	}
`;
exports.GET_WORK_HISTORY = `
  query getWorkHistory {
    getWorkHistory
  }
`;
exports.GET_PRACTICE_HISTORY = `
  query getPracticeRequirement {
    getPracticeRequirement
  }
`;
exports.GET_MIP_PRACTICE_DETAILS = `
  query getMipDetails {
    getMipDetails
  }
`;
exports.CREATE_AML_ATTESTATION = `
	mutation createAmlAttestation($aml: AmlAttestation){
		createAmlAttestation(aml: $aml) 
	}
`;
exports.CREATE_MIP_ATTESTATION = `
	mutation createMipAttestation($mip: MipAttestation){
		createMipAttestation(mip: $mip) 
	}
`;
exports.MUTATE_SEND_ORDER_CONFIRMATION_MIP = `
	mutation sendMipOrderConfirmationMail($payload: MipConfirmationDE){
		sendMipOrderConfirmationMail(payload: $payload) 
	}
`;
exports.QUERY_MIP_AML = `
  query getMipAml {
    getMipAml
  }
`;
exports.QUERY_MIP_AML_ATTESTATION = `
  query getMipAmlAttestation {
    getMipAmlAttestation
}
`;
exports.QUERY_MIP_ATTESTATION = `
  query getMipAttestation($practiceRequirementId: String) {
    getMipAttestation(practiceRequirementId: $practiceRequirementId)
  }
`;
exports.QUERY_MIP_CONTACT = `
  query getMipContact {
    getMipContact
  }
`;
exports.UPDATE_PRACTICE_REQUIREMENT = `
	mutation updatePracticeRequirement($practiceRequirement: PracticeDetails){
		updatePracticeRequirement(practiceRequirement: $practiceRequirement) 
	}
`;
exports.DELETE_MIP_RECORDS = `
	mutation deleteMipRecords{
		deleteMipRecords
	}
`;
//# sourceMappingURL=mip-queries.js.map